
export class UserScheduleCompensationWaitQueue {
    compensationWaitQueueID: number;
    studentID: number;
    index: number;
}